import CommandCard from '@/components/client/command-card';
import {
	$appendClientDetailActions,
	$clientDetailActions,
	$setClientDetailActions,
} from '@/entities/client.entity';
import { SOCKET_EVENTS } from '@/api/socket-events';
import { useClientVirtualFeed } from '@/hooks/use-client-virtual-feed';
import { getMockActionsForClient, paginateMockItems } from '@/mocks/fixtures';
import { useUnit } from 'effector-react';
import { getCommandTypeInfo } from '@/components/client/command-type-info';
import { phoneMatchesQuery } from '@/lib/format-phone';

interface ClientCommandsListProps {
	clientId: string;
	searchText: string;
	enabled: boolean;
	onCopy: (text: string) => void;
}

export default function ClientCommandsList({ clientId, searchText, enabled, onCopy }: ClientCommandsListProps) {
	const [actions, setActions, appendActions] = useUnit([
		$clientDetailActions,
		$setClientDetailActions,
		$appendClientDetailActions,
	]);

	const { listRef, content } = useClientVirtualFeed({
		clientId,
		searchText,
		enabled,
		fetchEvent: SOCKET_EVENTS.getClientActions,
		responseEvent: SOCKET_EVENTS.addClientActions,
		items: actions,
		setItems: setActions,
		appendItems: appendActions,
		getItemId: item => item.id,
		emptyLabel: 'Команд нет',
		renderItem: action => <CommandCard action={action} onCopy={onCopy} />,
		devMockFetch: ({ cursor, searchText: q }) => {
			const page = paginateMockItems(
				getMockActionsForClient(clientId),
				{ cursor, searchText: q },
				(item, query) => {
					const typeLabel = getCommandTypeInfo(item).label.toLowerCase();
					const text = item.params?.text?.toLowerCase() ?? '';
					return (
						typeLabel.includes(query) ||
						text.includes(query) ||
						phoneMatchesQuery(item.params?.phone, q) ||
						item.type.toLowerCase().includes(query)
					);
				},
			);
			return { clientId, ...page };
		},
	});

	return (
		<div ref={listRef} data-scroll-container className='h-full overflow-auto pr-1 px-1'>
			{content}
		</div>
	);
}
